module.exports = __webpack_public_path__ + "assets/img/gitlab.c58f6614.png";